module.exports = __webpack_public_path__ + "assets/img/download-active.23ec157f.svg";